// extracted by mini-css-extract-plugin
export var content = "breadcrumb-item-module--content--99a57";
export var item = "breadcrumb-item-module--item--6f5d0";
export var marker = "breadcrumb-item-module--marker--325b6";